$(document).ready(function() {
  var elem = document.querySelector(".seccion-publica-terraza");
  if (elem == null) {
    return;
  }

  // $(window).scroll(function () {
  //   scrollFooterPasos();
  // })


  var mapa;
  var vueAppPublicaTerraza;
  const loader = new MapaLoader({
    apiKey: googleApiKey
  });

  loader.importLibrary("maps").then(({Map}) => {
    mapa = new Map(document.getElementById("mapa"), {
      center: { lat: 20.639417, lng: -103.345308 },
      zoom: 11,
      gestureHandling: "greedy",
      controls: false,
      mapTypeControl: false,
      fullscreenControl: false,
      streetViewControl: false,
      draggableCursor: 'default',
      styles: window.MapaStyle
    });

    google.maps.event.addListener(mapa, 'center_changed', function(e) {
      if(vueAppPublicaTerraza.direccion != null){
        vueAppPublicaTerraza.direccion.lat = mapa.getCenter().lat()
        vueAppPublicaTerraza.direccion.lng = mapa.getCenter().lng()
      }
    });

    if(vueAppPublicaTerraza != null){
      vueAppPublicaTerraza.$refs.direccion.init(mapa);
      if(vueAppPublicaTerraza.direccion != null){
        vueAppPublicaTerraza.$refs.direccion.setLocation(vueAppPublicaTerraza.direccion.address,
          vueAppPublicaTerraza.direccion.ciudad,
          vueAppPublicaTerraza.direccion.lat, vueAppPublicaTerraza.direccion.lng)
        mapa.setZoom(17);
      }
    }
  });


  vueAppPublicaTerraza = new Vue({
    el: elem,
    data: {
      horaPickerOptiones: {
        start: '00:00',
        step:'00:30' ,
        end: '23:30'
      },

      terraza: {descripcion: "", min_horas: 5, precio_hora_extra: 0},

      paso: 1,

      agregandoServicio: false,

      servicios: [],
      servicio: {},
      servicioIndex: -1,

      tiposEventos: [],

      amenidades: [],

      dias: ["", "Lunes", "Martes", "Miércoles",
        "Jueves", "Viernes", "Sábado", "Domingo"],

      precios: [],
      indexHorario: -1,
      horarioPersonas: [],

      imagenes: [
        {
          id: null,
          placeholder: "Sube tu portada",
          url: null,
          url_file: null,
          file: null,
          multiple: false,
          cancelable: true,
        },
      ],

      direccion: null,

      enviandoInformacion: false,

      errorPortada: false

    },
    mounted() {

      this.tiposEventos = tiposEventosJson.map(item => ({...item, ...{activo: false}}))
      this.amenidades = amenidadesJson.map(item => ({...item, ...{activo: false}}))

      if(terrazaJson != null){
        this.terraza = Object.assign({}, terrazaJson)
        for (let i in terrazaJson.amenidades){
          let indexFound = this.amenidades.findIndex(item => item.id == terrazaJson.amenidades[i].id)
          if(indexFound > -1){
            this.amenidades[indexFound].activo = true
          }
        }
        for (let i in terrazaJson.tipos_eventos){
          let indexFound = this.tiposEventos.findIndex(item => item.id == terrazaJson.tipos_eventos[i].id)
          if(indexFound > -1){
            this.tiposEventos[indexFound].activo = true
          }
        }

        this.servicios = Object.assign([], terrazaJson.servicios)

        let portada = {
          id: null,
          placeholder: "Sube tu portada",
          url: terrazaJson.imagen,
          url_file: null,
          file: null,
          multiple: false,
          cancelable: true,
        }

        this.imagenes = []
        this.imagenes.push(portada)
        for (let i in terrazaJson.imagenes){
          let img = terrazaJson.imagenes[i]
          this.imagenes.push({
            id: img.id,
            placeholder: "Sube tus imágenes",
            url: img.imagen,
            file: null,
            url_file: null,
            multiple: true,
            cancelable: true
          })
        }
        this.imagenes.push({
          id: null,
          placeholder: "Sube tus imágenes",
          url: null,
          file: null,
          url_file: null,
          multiple: true,
          cancelable: true
        })

        for (let i = 1; i < 8; i++) {
          let dia = i
          let preciosJson = terrazaJson.precios.filter(item => item.dia_semana == dia)
          if(preciosJson.length == 0){
            this.precios.push({
              dia_semana: dia,
              hora_inicio: null,
              hora_fin: null,
              // min_horas: null,
              precio: null,
              precio_hora_extra: null,
              // precio_extra: null,
              extras: {}
            })
          }
          else{
            let fecha = dayjs().format('YYYY-MM-DD')
            for(let index in preciosJson){
              preciosJson[index].hora_inicio = dayjs(fecha + " " + preciosJson[index].hora_inicio, "YYYY-MM-DD HH:mm:ss").toDate()
              preciosJson[index].hora_fin = dayjs(fecha + " " + preciosJson[index].hora_fin, "YYYY-MM-DD HH:mm:ss").toDate()
              if(index != 0){
                preciosJson[index].extra = true
              }
              if(preciosJson[index].extras == null){
                preciosJson[index].extras = {}
              }
            }
            this.precios = [...this.precios,...preciosJson]
          }
        }
      }
      else{
        for (let i = 1; i < 8; i++){
          let dia = i
          this.precios.push({
            dia_semana: dia,
            hora_inicio: null,
            hora_fin: null,
            // min_horas: null,
            precio: null,
            precio_hora_extra: null,
            extras: {}
            // precio_extra: null
          })
        }
      }

      this.validarFormPaso1();

      if(this.terraza.direccion != null && this.terraza.direccion_lat != null
        && this.terraza.direccion_lng != null){
        this.direccion = {
          address: this.terraza.direccion,
          ciudad: this.terraza.ciudad,
          lat: this.terraza.direccion_lat,
          lng: this.terraza.direccion_lng
        }
      }

      if(mapa != null){
        this.$refs.direccion.init(mapa);
        if(this.direccion != null){
          this.$refs.direccion.setLocation(this.direccion.address,
            this.direccion.lat, this.direccion.lng)
          mapa.setZoom(19);
        }
      }

      // this.cargarDatosCache();

      // $('[data-toggle="tooltip"]').tooltip();
      this.crearTooltips();
    },
    methods: {
      ocultarTooltips(){
        $('[data-toggle="tooltip"]').tooltip('hide');
      },
      crearTooltips(){
        setTimeout(() => {
          $('[data-toggle="tooltip"]').tooltip();
        }, 400)
      },
      actualizarInfo(index, attr){
        let allIsNotEdited = this.precios.filter(item => item[attr] == null).length
        if(index == 0 && allIsNotEdited == this.precios.length - 1){
          for(let i = 1; i < this.precios.length; i++){
            this.precios[i][attr] = this.precios[index][attr]
          }
        }
      },
      horaFormato(hora){
        let dayjsFormat = dayjs(hora)
        if(!dayjsFormat.isValid()){
          return ''
        }
        return dayjsFormat.format('HH:mm') ?? ''
      },
      agregarPreciosPersonas(index){
        this.ocultarTooltips()
        this.indexHorario = index
        let extras = this.precios[index].extras
        this.horarioPersonas = []
        if(extras != null && extras.personas != null){
          this.horarioPersonas = Object.assign([], extras.personas)
        }
        if(this.horarioPersonas.length == 0){
          this.agregarPersonas()
        }
        $("#modalHorarioPersonas").modal('show');
      },
      agregarPersonas(){
        this.horarioPersonas.push({
          min: null,
          max: null,
          precio: null
        })
      },
      removerPersonas(index){
        this.horarioPersonas.splice(index,1)
        if(this.horarioPersonas.length == 0){
          this.agregarPersonas()
        }
      },
      guardarPersonas(){
        console.log(this.horarioPersonas)
        if(this.horarioPersonas.length == 1
        && (this.horarioPersonas[0].min == null || this.horarioPersonas[0].min.length == 0)
          && (this.horarioPersonas[0].max == null || this.horarioPersonas[0].max.length == 0)
          && (this.horarioPersonas[0].precio == null || this.horarioPersonas[0].precio.length == 0)){
          this.horarioPersonas = []
        }
        else{
          for(let index in this.horarioPersonas){
            let item = this.horarioPersonas[index]
            let numFila = parseInt(index) + 1
            if(item.min == null || item.min.length == 0){
              Alert("Ingresa la cantidad mínima, revisa la fila " + numFila, "info")
              return
            }
            if(item.max == null || item.max.length == 0){
              Alert("Ingresa la cantidad máxima, revisa la fila " + numFila, "info")
              return
            }
            if(item.precio == null || item.precio.length == 0){
              Alert("Ingresa el precio, revisa la fila " + numFila, "info")
              return
            }

            if(parseInt(item.min) > parseInt(item.max)){
              Alert("La cantidad mínima no puede ser mayor a la máxima, revisa la fila " + numFila, "info")
              return
            }
          }
        }

        let extras = this.precios[this.indexHorario].extras
        if(extras == null){
          extras = {}
        }
        extras.personas = Object.assign([], this.horarioPersonas)

        this.precios[this.indexHorario].extras = Object.assign({}, extras)

        $("#modalHorarioPersonas").modal('hide');
      },
      agregarDia(index){
        this.ocultarTooltips()
        let extra = {
          dia_semana: this.precios[index].dia_semana,
          hora_inicio: null,
          hora_fin: null,
          // min_horas: null,
          precio: null,
          precio_hora_extra: null,
          // precio_extra: null,
          extra: true,
          extras: {}
        }

        this.precios.splice(index+1,0,extra)
        this.crearTooltips();
      },
      removerDia(index){
        this.ocultarTooltips()
        if(this.precios[index].extra){
          this.precios.splice(index,1)
        }
        else{
          this.precios[index].hora_inicio = null
          this.precios[index].hora_fin = null
          // this.precios[index].min_horas = null
          this.precios[index].precio = null
          this.precios[index].precio_hora_extra = null
          // this.precios[index].precio_extra = null
        }
      },
      direccionChange(){
        if(this.direccion != null){
          mapa.setCenter({ lat: this.direccion.lat, lng: this.direccion.lng });
          mapa.setZoom(19);
        }
      },
      preciosCompletados(){
        return this.precios.filter(item => {
          return item.hora_inicio != null
            && item.hora_fin != null
            && item.precio != null && (item.precio + "").length > 0
        })
      },
      validarFormPasoPrecios(){
        let preciosCompletos = vueAppPublicaTerraza.preciosCompletados()

        if(preciosCompletos.length == 0){
          Alert("Configura los precios de mínimo un día", "info")
          return
        }
        this.sumarPaso();
      },
      validarFormPasoDireccion(siguiente = true){
        if(this.direccion == null){
          Alert("Selecciona dirección", "info")
          return
        }
        if(siguiente){
          this.sumarPaso();
        }
        else{
          this.validarEnivarTerraza();
        }
      },
      validarFormPasoImagenes(){
        if(this.imagenes[0].url == null
          && this.imagenes[0].url_file == null){
          this.errorPortada = true
          Alert("Selecciona una imagen de portada", "info")
          this.$forceUpdate()
          return
        }

        if(this.imagenes.length < 4){
          Alert("Selecciona mínimo tres imágenes", "info")
          return
        }

        this.sumarPaso();
      },
      validarFormPaso1(){
        $('#formGeneral').validarForm((form) => {

          let totalTiposEventos = vueAppPublicaTerraza.tiposEventos.filter(item => item.activo)
          if(totalTiposEventos.length == 0){
            Alert("Selecciona mínimo un tipo de evento", "info")
            return
          }
          vueAppPublicaTerraza.sumarPaso();
        })
      },
      siguientePaso(opcion = 2){
        if(this.enviandoInformacion){
          return;
        }
        if(this.paso == 1){
          $('#submitPaso1')[0].click();
        }
        else if(this.paso == 2){
          if(opcion == 2){
            this.validarFormPasoPrecios()
          }
          else{
            this.validarFormPasoImagenes();
          }
        }
        else if(this.paso == 3){
          if(opcion == 2) {
            this.sumarPaso();
          }
          else{
            this.validarFormPasoDireccion();
          }
        }
        else if(this.paso == 4){
          if(opcion == 2){
            this.validarFormPasoImagenes()
          }
          else{
            this.validarFormPasoPrecios()
          }
        }
        else if(this.paso == 5){
          if(opcion == 2){
            this.validarFormPasoDireccion(false);
          }
          else{
            this.validarEnivarTerraza();
          }
        }
        else{
          this.sumarPaso();
        }
      },
      sumarPaso(){
        this.paso += 1
        location.hash = "paso_" + this.paso
        window.scrollTo(0, 0);


        // let localData = localStorage.getItem("terrazas")
        // if(localData == null){
        //   localData = {}
        // }
        // else{
        //   localData = JSON.parse(localData)
        // }
        // let tiposEventosSeleccionados = this.tiposEventos.filter(item => item.activo).map(item => item.id);
        // let amenidadesSeleccionadas = this.amenidades.filter(item => item.activo).map(item => item.id);
        // let key = this.terraza.id ?? "0";
        //
        // let imagenes = Object.assign([], this.imagenes)
        // console.log(this.direccion)
        // localData[key] = {
        //   terraza: this.terraza,
        //   precios: this.precios,
        //   imagenes: imagenes,
        //   direccion: this.direccion,
        //   tipos_eventos: tiposEventosSeleccionados,
        //   amenidades: amenidadesSeleccionadas,
        //   paso: this.paso,
        //   fecha: new Date()
        // }
        //
        // localStorage.setItem("terrazas", JSON.stringify(localData))
      },
      atrasPaso(){
        if(this.enviandoInformacion){
          return
        }
        this.paso -= 1
        window.scrollTo(0, 0);

        location.hash = "paso_" + this.paso
      },

      validarServicioForm(){
        $('#formServicio').validarForm((form) => {
          vueAppPublicaTerraza.guardarServicio(form)
        })
      },
      removerServicio(index){
        AlertConfirm("¿Eliminar servicio?", "warning").then((ok) => {
            if (ok) {
              vueAppPublicaTerraza.servicios.splice(index, 1)
            }
          });

      },
      cancelarServicio(){
        this.agregandoServicio = false
      },
      agregarServicio(){
        this.servicio = Object.assign({}, {is_por_persona: false});
        this.servicioIndex = -1
        this.agregandoServicio = true
        this.validarServicioForm()

        setTimeout(() => {
          document.querySelector("#servicioNombre").focus()
        }, 200)
      },
      editarServicio(index){
        this.servicio = Object.assign({}, this.servicios[index]);
        this.servicioIndex = index
        this.agregandoServicio = true
        this.validarServicioForm()
      },
      guardarServicio(form){
        this.agregandoServicio = false
        if(this.servicioIndex == -1) {
          this.servicios.push(this.servicio)
        }
        else{
          this.servicios.splice(this.servicioIndex, 1, this.servicio)
        }
      },

      removerImagen(index){
        if(index == 0){
          this.imagenes.splice(index, 1, {
            id: null,
            placeholder: "Sube tu portada",
            url: null,
            url_file: null,
            file: null,
            multiple: false,
            cancelable: true
          })
        }
        else{
          this.imagenes.splice(index, 1)
        }
      },

      async pickImagen(e){
        let maxSizeBytes = 5 * 1024 * 1024
        let index = parseInt(e.srcElement.dataset.index)
        if(index == 0){
          this.errorPortada = false
        }
        let archivosNoAceptados = ""
        if(e.srcElement.files.length > 0){
          let file = e.srcElement.files[0]
          if (file.size > maxSizeBytes) {
            archivosNoAceptados += file.name + ", "
          }
          else {
            this.imagenes[index].file = file
            this.imagenes[index].file_b64 = await toBase64(file)
            this.imagenes[index].url_file = URL.createObjectURL(file)
          }
        }

        if(e.srcElement.files.length > 1){
          for (let i = 1; i < e.srcElement.files.length; i++){
            let file = e.srcElement.files[i]
            if (file.size > maxSizeBytes) {
              archivosNoAceptados += file.name + ", "
            }
            else{
              if(this.imagenes[index + i] != null &&
                this.imagenes[index + i].url == null &&
                this.imagenes[index + i].url_file == null){
                this.imagenes[index + i].file = e.srcElement.files[0]
                this.imagenes[index + i].file_b64 = await toBase64(file)
                this.imagenes[index + i].url_file = URL.createObjectURL(e.srcElement.files[0])
              }
              else{
                this.imagenes.push({
                  id: null,
                  placeholder: "Sube tus imágenes",
                  url: null,
                  file: e.srcElement.files[i],
                  url_file: URL.createObjectURL(e.srcElement.files[i]),
                  multiple: true,
                  cancelable: true
                })
              }
            }

          }
        }
        if(this.imagenes[this.imagenes.length -1].url != null
          || this.imagenes[this.imagenes.length-1].file != null){
          this.imagenes.push({
            id: null,
            placeholder: "Sube tus imágenes",
            url: null,
            file: null,
            url_file: null,
            multiple: true,
            cancelable: true
          })
        }
        e.srcElement.value = "";
        this.$forceUpdate()

        if(archivosNoAceptados.length > 0){
          archivosNoAceptados = archivosNoAceptados.substring(0, archivosNoAceptados.length -2)
          Alert("Los archivos " + archivosNoAceptados + " exceden los 5mb", "info")
        }
      },

      async pickImagenServicio(e){
        if(e.srcElement.files.length > 0){
          this.servicio.file = e.srcElement.files[0]
          this.file_b64 = await toBase64(e.srcElement.files[0])
          this.servicio.url_file = URL.createObjectURL(e.srcElement.files[0])
        }
        e.srcElement.value = "";
        this.$forceUpdate()
      },

      validarEnivarTerraza(){
        if(this.enviandoInformacion){
          return;
        }

        if(this.agregandoServicio){
          Alert("Termina de modificar el servicio", "info")
          return
        }

        let formData = new FormData();
        if(this.terraza.id != null){
          formData.append("id", this.terraza.id)
        }
        formData.append("nombre", this.terraza.nombre)
        formData.append("min_personas", this.terraza.min_personas)
        formData.append("max_personas", this.terraza.max_personas)
        // if(this.terraza.precio_hora_extra != null){
        //   formData.append("precio_hora_extra", this.terraza.precio_hora_extra)
        // }
        formData.append("min_horas", this.terraza.min_horas)
        formData.append("descripcion", this.terraza.descripcion)

        let preciosCompletados = Object.assign([], this.preciosCompletados())
        for (let index in preciosCompletados){
          let item = Object.assign({}, preciosCompletados[index])
          item.hora_inicio = dayjs(item.hora_inicio).format('HH:mm')
          item.hora_fin = dayjs(item.hora_fin).format('HH:mm')
          preciosCompletados[index] = item
        }
        formData.append("precios", JSON.stringify(preciosCompletados))

        if(this.direccion != null){
          formData.append("direccion", this.direccion.address)
          formData.append("ciudad", this.direccion.ciudad)
          formData.append("direccion_lat", this.direccion.lat)
          formData.append("direccion_lng", this.direccion.lng)
        }
        for(let index in this.imagenes){
          let imagen = this.imagenes[index]
          if(imagen.id != null){
            formData.append("imagenes["+index+"][id]", imagen.id)
          }
          if(imagen.file != null){
            formData.append("imagenes["+index+"][imagen]", imagen.file)
          }
        }

        let tiposEventosSeleccionados = this.tiposEventos.filter(item => item.activo).map(item => item.id);
        formData.append("tipos_eventos", JSON.stringify(tiposEventosSeleccionados))
        let amenidadesSeleccionadas = this.amenidades.filter(item => item.activo).map(item => item.id);
        formData.append("amenidades", JSON.stringify(amenidadesSeleccionadas))

        for(let index in this.servicios){
          let servicio = this.servicios[index]
          formData.append("servicios["+index+"][json]", JSON.stringify(servicio))
          if(servicio.file != null){
            formData.append("servicios["+index+"][imagen]", servicio.file)
          }
        }

        this.enviandoInformacion = true

        axios
          .post("/publica-tu-terraza", formData)
          .then((respuesta) => {
            vueAppPublicaTerraza.enviandoInformacion = false
            if (respuesta.data.error) {
              Alert(respuesta.data.error, "info")
              return
            }
            vueAppPublicaTerraza.sumarPaso()
          })
          .catch((error) => {
            ReportErrorLog(error)
            console.error(error)
            vueAppPublicaTerraza.enviandoInformacion = false
            Alert("Ocurrió un error inesperado", "info")
          })
      },

      cargarDatosCache(){
        let key = this.terraza.id ?? "0"
        let paso = 1
        if(location.hash != null && location.hash.length > 0){
          let pasoHash = location.hash.split("_")
          if(pasoHash.length > 1){
              paso = parseInt(pasoHash[1])
            if(isNaN(paso)){
              paso = 1
            }
          }
        }

        let terrazasJson = localStorage.getItem("terrazas");
        if(terrazasJson != null){
          let terrazas = JSON.parse(terrazasJson)
          if(terrazas[key] != null){
            let terraza = terrazas[key]
            const timeDifference = Math.abs(new Date(terraza.fecha).getTime() - new Date().getTime());
            const dayDifference = timeDifference / (1000 * 3600 * 24);

            if (dayDifference <= 3) {
              AlertConfirm("¿Quieres continuar en donde te quedaste la última vez?",
                "warning").then((ok) => {
                if (ok) {
                  vueAppPublicaTerraza.terraza = terraza.terraza
                  vueAppPublicaTerraza.direccion = terraza.direccion
                  vueAppPublicaTerraza.amenidades = vueAppPublicaTerraza.amenidades.map(item => {
                    item.activo = terraza.amenidades.includes(item.id)
                    return item
                  })
                  vueAppPublicaTerraza.tiposEventos = vueAppPublicaTerraza.tiposEventos.map(item => {
                    item.activo = terraza.tipos_eventos.includes(item.id)
                    return item
                  })

                  for(let i in terraza.imagenes){
                    let imagen = terraza.imagenes[i]
                    if(imagen.file_b64 != null){
                      terraza.imagenes[i].file = base64ToBlob(imagen.file_b64)
                      terraza.imagenes[i].url_file = imagen.file_b64
                    }
                  }
                  vueAppPublicaTerraza.imagenes = terraza.imagenes

                  if(terraza.paso < paso){
                    paso = terraza.paso
                  }
                  vueAppPublicaTerraza.paso = paso
                  location.hash = "paso_" + paso
                }
              });
            }
            else{
              delete terrazas[key]
              localStorage.setItem("terrazas", JSON.stringify(terrazas));
            }
          }
          else{
            location.hash = null
          }
        }

      }
    }
  });


  $(".slider-range.personas").slider({
    range: true,
    min: 1,
    max: 10,
    values: [1, vueAppPublicaTerraza.terraza.min_horas],
    start: function( event, ui ) {

    },
    slide: function( event, ui ) {
      if(!$(ui.handle).hasClass("no-modificar")){
        $(ui.handle).attr("personas", 'por '+ui.values[1]+ ' horas')
        vueAppPublicaTerraza.terraza.min_horas = ui.values[1]
      }
      else{
        event.preventDefault()
      }
    }
  });
  $($('span.ui-slider-handle.ui-corner-all.ui-state-default')[0]).addClass("no-modificar")
  $($('span.ui-slider-handle.ui-corner-all.ui-state-default')[1]).attr("personas", 'por '+vueAppPublicaTerraza.terraza.min_horas+' horas')


  const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

  async function base64ToBlob(base64String) {
    if (!base64String || !base64String.includes(',')) {
      console.error('La cadena Base64 no está definida o tiene un formato incorrecto.');
      return;
    }
    let b64Array = await base64String.split(',')
    const base64 = b64Array[1];
    const mimeType = base64String.match(/:(.*?);/)[1];

    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mimeType });
  }


});
